// Pipeline stage colors for consistency
export const PIPELINE_COLORS = {
  'Lead Stage': '#1976d2',
  'Discovery Stage': '#0288d1',
  'Proposal Stage': '#ff9800',
  'Contract Stage': '#d32f2f',
  'Closed Stage': '#757575'
};

// Map status to pipeline stage colors
export const getStatusColor = (status) => {
  const stageMapping = {
    'New': 'Lead Stage',
    'Attempt to Contact': 'Lead Stage',
    'Engaged': 'Discovery Stage',
    'Discovery': 'Discovery Stage',
    'Proposal': 'Proposal Stage',
    'Refinement': 'Proposal Stage',
    'Retirement': 'Proposal Stage',
    'Contract Sent': 'Contract Stage',
    'Closed Won': 'Closed Stage',
    'Closed Lost': 'Closed Stage',
    'Closed Dead': 'Closed Stage'
  };
  const stage = stageMapping[status] || 'Lead Stage';
  return PIPELINE_COLORS[stage] || '#757575';
};

export const RECENCY_OPTIONS = [
  { value: null, label: 'All' },
  { value: 7, label: '7d' },
  { value: 14, label: '14d' },
  { value: 30, label: '30d' },
  { value: 60, label: '60d' },
  { value: 90, label: '90d' },
];

export const EMPTY_SET = new Set();

// Default filter state shape
export const getDefaultFilterState = () => ({
  statuses: EMPTY_SET,
  leadTypes: EMPTY_SET,
  strategies: EMPTY_SET,
  selectedStages: EMPTY_SET,
  text: '',
  lastUpdatedDays: null,
  lastEngagedDays: null,
  lastCreatedDays: null,
  sizeBuckets: EMPTY_SET,
  duplicatesOnly: false,
  legacyLeadsOnly: false,
  funnelStages: EMPTY_SET,
  strategicAccounts: EMPTY_SET,
});
